import React, { useContext } from 'react'
import { SkyInformationPopover } from './SkyPopover'
import {
  FirebaseService,
  FirebaseConfigKey,
} from '../../../services/FirebaseService'
import {
  InsurancePurchaseContextStore,
  INSURANCE_CONTEXT_ACTIONS,
} from '../../../context/InsuracePurchaseContext'
import {
  PolicyHullExtensionContextStore,
  ACTIONS,
} from '../../../context/PolicyHullExtensionContext'
import { useLocation, useParams } from 'react-router-dom'
import { InsuranceBillingPeriod } from '../../../models/insurance-models/InsuranceBillingPeriodModel'
import { COUNTRIES } from '../../../Constants'
import { isCanada } from '../../../services/utils'
var classNames = require('classnames')

export const WorldWidePopover = (props) => {
  const location = useLocation()
  const insurancePurchaseContext = useContext(InsurancePurchaseContextStore)

  return (
    <SkyInformationPopover eventId={'worldwide-coverage'}>
      {isCanada() ? (
        <>
          <div className="text-small">
            {' '}
            - SkyWatch.AI's standard coverage territory is anywhere in Canada.
          </div>
          <div className="text-small">
            {' '}
            - Policies can be expanded to include commercial operations in the
            US as well.
          </div>
          <div className="text-small">
            {' '}
            - To add worldwide coverage outside of the US, contact us.
          </div>
        </>
      ) : (
        <div className="text-small">
          The coverage territory for SkyWatch.AI policies is anywhere in{' '}
          {FirebaseService.getValue(FirebaseConfigKey.PRETTY_COUNTRY_NAME)}. For
          worldwide coverage territory for commercial purposes, contact us.
        </div>
      )}
    </SkyInformationPopover>
  )
}
